var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Teacher Pay",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "soli-subtitle" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.globalMomentMonthFull(
                                        _vm.rangeStart
                                      )} ${_vm.globalMomentYear(
                                        _vm.rangeStart
                                      )}`
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticStyle: { "white-space": "normal" } },
                                [
                                  _vm._v(
                                    "Monthly pay due to\n                                teachers"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "font-bold",
                                  staticStyle: { "white-space": "normal" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.total) +
                                      " earned in\n                                " +
                                      _vm._s(_vm.teachers.length) +
                                      " teacher(s)\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-3",
                                      attrs: {
                                        small: _vm.$vuetify.breakpoint.xs,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.range(-1)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "dark" } },
                                        [_vm._v("chevron_left")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-3 ml-1",
                                      attrs: {
                                        small: _vm.$vuetify.breakpoint.xs,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.range(1)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "dark" } },
                                        [_vm._v("chevron_right")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$vuetify.breakpoint.xs
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            right: "",
                                            "close-on-content-click": false,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "elevation-3 ml-1",
                                                            attrs: {
                                                              small:
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .xs,
                                                              icon: "",
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-badge",
                                                          {
                                                            attrs: {
                                                              color: "accent",
                                                              overlap: "",
                                                              bordered: "",
                                                              dot: "",
                                                              value: _vm.search,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "soli-blue-text text-shadow-blue",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "filter_list"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1714063686
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-item",
                                                { staticClass: "pl-0" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pl-6 white pt-0 mt-0",
                                                    attrs: {
                                                      label: "Filter",
                                                      "single-line": "",
                                                      clearable: "",
                                                      "append-icon": _vm.search
                                                        ? null
                                                        : "filter_list",
                                                      "hide-details": "",
                                                    },
                                                    model: {
                                                      value: _vm.search,
                                                      callback: function ($$v) {
                                                        _vm.search = $$v
                                                      },
                                                      expression: "search",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.smAndUp
                            ? _c(
                                "v-list-item-action",
                                [
                                  _c("v-text-field", {
                                    staticClass: "pl-6",
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: "Filter",
                                      "single-line": "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function ($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.teachers,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "my-0",
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: { src: item.profile_photo_url },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.id}/manage`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.name) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.email) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.totalPay`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatUnitAmount(item.totalPay)
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }